import PassengerUpdateRequest, {
  PassengerUpdateRequestAddress,
  PassengerUpdateRequestPassenger,
} from "../../../api/raily/passenger/update/passenger-update.request";
import PassengerUpdateParams, {
  PassengerUpdateParamsAddress,
  PassengerUpdateParamsPassenger,
} from "./passenger-update-params";

const createPassengerAddress = (
  address: PassengerUpdateParamsAddress,
): PassengerUpdateRequestAddress => {
  return {
    apartment: address.apartment,
    country: address.country,
    description: address.description,
    houseNo: address.houseNo,
    lat: address.lat,
    lon: address.lon,
    street: address.street,
    town: address.town,
    zipCode: address.zipCode,
  };
};

const createPassengerAddresses = (
  addresses: PassengerUpdateParamsAddress[],
): PassengerUpdateRequestAddress[] => {
  return addresses.map(createPassengerAddress);
};

const createPassenger = (
  passenger: PassengerUpdateParamsPassenger,
): PassengerUpdateRequestPassenger => {
  return {
    addresses: passenger.addresses,
    dispatchIds: passenger.dispatchIds,
  };
};

const create = (params: PassengerUpdateParams): PassengerUpdateRequest => {
  return {
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    mobilePrimary: params.mobilePrimary,
    mobilePrimaryPrefix: params.mobilePrimaryPrefix,
    mobileSecondary: params.mobileSecondary,
    mobileSecondaryPrefix: params.mobileSecondaryPrefix,
    passenger: params.passenger,
    passengerUuid: params.passengerUuid,
  };
};

const passengerUpdateParamsFactory = {
  create,
};

export default passengerUpdateParamsFactory;
